<template>
    <div class="user_order" v-loading="loading">
        <div class="order_titles">
            <div class="order_bordeer"></div>
            我的家人
        </div>
        <div class="user_order_box">
            <div class="order_list">
                <div class="list_item" v-for="(item,index) in lists " :key="index">
                    <div class="item_imgs">
                        <!-- <img src="@/assets/img/user_info/user_zl/user_img.png" alt=""> -->
                         <img :src="item.image" alt="">
                    </div>
                    <div class="item_info">
                        <div class="info_top">
                            <div class="text1">{{ item.name }}</div>
                            <div class="text2">{{ item.mobile }}</div>
                            <!-- 1普通用户,2律师-执业,3律师-非执业,4法律专家,5法律资格从业者,6工商企业,7律所 -->
                            <div class="text3" v-if="item.type==1">普通用户</div>
                            <div class="text3" v-if="item.type==2">律师-执业</div>
                            <div class="text3" v-if="item.type==3">律师-非执业</div>
                            <div class="text3" v-if="item.type==4">法律专家</div>
                            <div class="text3" v-if="item.type==5">法律资格从业者</div>
                            <div class="text3" v-if="item.type==6">工商企业</div>
                            <div class="text3" v-if="item.type==7">律所</div>
                        </div>
                        <div class="info_bom">
                            <!-- {{ item.created_at }} -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="pages_box">
                <div class="btns" @click="handle_pages(1)">首页</div>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    background
                    :page-size="pages.limit"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
                <div class="btns"  @click="handle_pages(10)">尾页</div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:1,
            type_list:[
                {
                    title:'全部消息',
                    state:1,
                },
                {
                    title:'系统消息',
                    state:2,
                },
                {
                    title:'活动消息',
                    state:3,
                },
                {
                    title:'服务通知',
                    state:4,
                }
                
            ],
            lists:[],

            total:0,
            pages:{
                page:1,
                limit:10,
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state
        },
        handle_seach(){
            console.log('点击搜索')
        },
        handleSizeChange(e){
            console.log('条数',e)            
        },
        handleCurrentChange(e){
            console.log('页数',e)
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
        },
        get_list(){
            this.loading=true
            this.$api("getXiaJiList", {
                ...this.pages,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的家人（粉丝）',res)
                if (res.code == 1) {
                    this.total=res.data.count
                    this.lists=res.data.list
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
       



    },

}
</script>
<style scoped lang="less">
.user_order {
    background: #FFFFFF;

    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        // padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #E5E5E5;
        .order_bordeer{
            width: 4px;
            height: 22px;
            background: #377CFD;
            border-radius: 3px 3px 3px 3px;
            margin-right: 28px;
        }
    }
    .user_order_box{
        padding: 24px 32px;    
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_list{
            .list_item{
                display: flex;
                align-items: center;
                padding: 20px 10px;
                border-bottom: 1px solid #E5E5E5;
                .item_imgs{
                    width: 90px;
                    height: 90px;
                    img{
                        width: 90px;
                        height: 90px;
                    }
                }
                .item_info{
                    padding-left: 30px;
                    .info_top{
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        .text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                        }
                        .text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                            margin-left: 20px;
                        }
                        .text3{
                            // width: 87px;
                            padding: 0 15px;
                            height: 31px;
                            background: #377CFD;
                            border-radius: 19px 19px 19px 19px;
                            text-align: center;
                            line-height: 31px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left: 25px;
                        }
                    }
                    .info_bom{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;

                    }
                }
            }
        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>